/**
 * Created by sofos on 20/08/16.
 */

import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
// import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  headers: Headers = new Headers({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  });
  api_url: string;

  constructor(private http: Http) {
    this.api_url = 'http://anadigit.fr'; // environment.api_url;
  }

  private getJson(response: Response) {
    //  console.log(response)
    return response.json();
  }

  private checkForError(response: Response): Response | Observable<any> {
    // console.log(response)
    if (response.status >= 200 && response.status < 300) {
      return response;
    } else {
      const error = new Error(response.statusText);
      error['response'] = response;
      console.error(error);
      throw error;
    }
  }

  get(path: string): Promise<any> {
    console.log(path);
    return new Promise((resolve, reject) => {
      this.http.get(`${this.api_url}${path}`, { headers: this.headers })
        .map(this.checkForError)
        // .catch(err => Observable.throw(err))
        .map(this.getJson)
        .subscribe(res => {
          resolve(res);
        });
    });

  }

  getFullPathProvided(path: string): Observable<any> {
    return this.http.get(path);
  }

  post(path: string, body: any): Observable<any> {
    return this.http.post(
      `${this.api_url}${path}`,
      JSON.stringify(body),
      { headers: this.headers }
    )
      .map(this.checkForError)
      // .catch(err => Observable.throw(err))
      .map(this.getJson);
  }

  delete(path: string): Observable<any> {
    return this.http.delete(
      `${this.api_url}${path}`,
      { headers: this.headers }
    )
      .map(this.checkForError)
      // .catch(err => Observable.throw(err))
      .map(this.getJson);
  }

  setHeaders(headers: any) {
    Object.keys(headers).forEach(header => this.headers.set(header, headers[header]));
  }
}



// WEBPACK FOOTER //
// /Users/sofos/projects/anadigit/kounoupia-data-entry/src/app/services/api.service.ts